import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData, reviews } from '@/mocks/comics';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="w-full relative h-[320px] md:h-[420px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warm%20artistic%20illustration%20for%20company%20about%20us%20page%20banner%2C%20soft%20warm%20orange%20and%20cream%20gradient%20background%2C%20stylized%20abstract%20comic%20reading%20scene%20with%20bookshelves%2C%20cozy%20library%20atmosphere%2C%20clean%20minimal%20composition%2C%20professional%20corporate%20digital%20art%2C%20high%20quality&width=1920&height=900&seq=about-hero&orientation=landscape"
            alt="关于韩漫网 - 韩漫免费阅读平台"
            title="关于我们 - 韩漫在线免费阅读平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="w-full max-w-[1280px] mx-auto">
                <p className="text-xs font-medium text-background-50/70 uppercase tracking-wider mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                  About Us
                </p>
                <h1 className="text-3xl md:text-5xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                  关于韩漫网
                </h1>
                <p className="mt-3 text-sm md:text-base text-background-50/80 max-w-xl">
                  致力于为全球漫画爱好者提供最优质的韩漫阅读体验
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 pt-6 md:pt-8">
          <div className="w-full max-w-[1280px] mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
              <div>
                <p className="text-xs font-medium text-primary-500 uppercase tracking-wider mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                  我们的故事
                </p>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
                  让好漫画<span style={{ fontFamily: 'var(--font-heading)', fontStyle: 'italic' }}>触手可及</span>
                </h2>
                <p className="mt-5 text-sm text-foreground-600 leading-relaxed">
                  {aboutData.brandIntro}
                </p>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  我们的使命是<strong>{aboutData.mission}</strong>。我们相信，好的故事应该被更多人看到，优秀的漫画作品值得被广泛传播。为此，我们不断优化平台体验，拓展漫画资源库，力求为每一位用户带来最好的阅读享受。
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4">
                {aboutData.stats.slice(0, 4).map((stat, i) => (
                  <div
                    key={i}
                    className={`p-6 rounded-lg ${
                      i === 0 ? 'bg-accent-500' : i === 1 ? 'bg-secondary-500' : 'bg-background-100'
                    } ${i <= 1 ? 'text-background-50' : 'text-foreground-950'}`}
                  >
                    <p className="text-3xl md:text-4xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                      {stat.value}
                    </p>
                    <p className="text-sm mt-1 opacity-80">{stat.suffix}{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center gap-2 mb-3">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs font-medium text-foreground-600 uppercase tracking-wider">用户口碑</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                听听读者们怎么说
              </h2>
              <p className="mt-3 text-sm text-foreground-500">数百万用户的真实评价，是我们前进的最大动力</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {reviews.map((review) => (
                <article key={review.id} className="p-6 rounded-lg bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${i < review.rating ? 'text-yellow-400' : 'text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2">{review.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">{review.content}</p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full relative h-[500px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warm%20artistic%20illustration%20for%20business%20contact%20page%20banner%2C%20soft%20warm%20orange%20and%20golden%20tones%2C%20stylized%20abstract%20comic%20collaboration%20scene%2C%20professional%20modern%20meeting%20atmosphere%2C%20clean%20minimal%20composition%2C%20high%20quality%20digital%20art&width=1920&height=1200&seq=about-cta&orientation=landscape"
            alt="商务合作 - 韩漫网"
            title="商务合作联系 - 韩漫在线"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4 max-w-2xl">
              <h2 className="text-3xl md:text-5xl font-bold text-background-50 uppercase tracking-wider" style={{ fontFamily: 'var(--font-heading)' }}>
                Business Cooperation
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-50/80 leading-relaxed">
                我们欢迎版权合作、内容授权、广告投放等各类商务合作。如有合作意向，请通过以下方式联系我们。
              </p>

              <div className="mt-8 flex flex-col items-center gap-4">
                <div className="flex items-center gap-3 text-background-50/90">
                  <i className="ri-mail-line text-lg"></i>
                  <span className="text-sm">{aboutData.contactEmail}</span>
                </div>
                <div className="flex items-center gap-3 text-background-50/90">
                  <i className="ri-phone-line text-lg"></i>
                  <span className="text-sm">{aboutData.contactPhone}</span>
                </div>
                <div className="flex items-center gap-3 text-background-50/90">
                  <i className="ri-map-pin-line text-lg"></i>
                  <span className="text-sm">{aboutData.address}</span>
                </div>
              </div>

              <a
                href={`mailto:${aboutData.contactEmail}`}
                className="mt-8 inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold whitespace-nowrap rounded-full bg-background-50 text-foreground-950 hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-shopping-bag-line"></i>
                联系我们
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: 'var(--font-heading)' }}>
              常见问题
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl mx-auto">
              {faqItems.map((faq, i) => (
                <details key={i} className="group p-5 rounded-lg bg-background-100 cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-950 list-none flex items-center justify-between">
                    {faq.question}
                    <i className="ri-add-line text-foreground-400 group-open:hidden"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于韩漫网 - 韩漫免费阅读平台',
          description: '韩漫网是国内领先的韩国漫画免费阅读平台，致力于为广大漫画爱好者提供海量优质的韩漫资源。',
          url: 'http://ryjfh.cn/about',
          mainEntity: {
            '@type': 'Organization',
            name: '韩漫网',
            description: aboutData.brandIntro,
            url: 'http://ryjfh.cn/',
            contactPoint: {
              '@type': 'ContactPoint',
              email: aboutData.contactEmail,
              telephone: aboutData.contactPhone,
              contactType: 'business cooperation',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: aboutData.address,
            },
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'http://ryjfh.cn/' },
            { '@type': 'ListItem', position: 2, name: '关于我们' },
          ],
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqItems.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        })}
      </script>
    </>
  );
}

const faqItems = [
  {
    question: '韩漫网上的漫画都是免费的吗？',
    answer: '是的，韩漫网上所有漫画均可免费阅读。我们致力于为广大漫画爱好者提供优质的免费阅读体验，让好漫画触手可及。部分独家内容可能需要注册登录后阅读。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们每日更新500+话漫画内容，与韩国最新连载保持同步。热门漫画一般每周更新1-2话，确保读者能够第一时间看到最新内容。',
  },
  {
    question: '如何在手机上阅读韩漫？',
    answer: '韩漫网支持手机浏览器直接访问，无需下载APP。在手机浏览器中打开韩漫网，即可享受适配移动端的流畅阅读体验。同时支持收藏功能，方便随时继续阅读。',
  },
  {
    question: '如何联系我们进行商务合作？',
    answer: '您可以通过邮箱 hello@ryjfh.cn 或电话 400-888-6666 联系我们。我们欢迎版权合作、内容授权、广告投放等各类商务合作，期待与您携手共赢。',
  },
  {
    question: '韩漫网的漫画有版权吗？',
    answer: '韩漫网高度重视知识产权保护，所有作品均已获得正版授权或与版权方达成合作协议。如您发现任何版权问题，请通过联系我们页面与我们取得联系，我们将第一时间处理。',
  },
  {
    question: '支持离线下载阅读吗？',
    answer: '目前韩漫网暂不支持离线下载功能。为保证最佳阅读体验和内容安全，建议您在网络环境下在线浏览。我们正在评估离线阅读功能的可行性，敬请期待。',
  },
];